export default __webpack_public_path__ + "static/media/1184.58c0b0e0.png";